import React, {Component} from 'react';
import {
    Button,
    Row,
    Col,
    FormControl
} from '@sketchpixy/rubix'
import LoadingContainer from "../components/LoadingContainer";

class UnableToExamModal extends Component {
    constructor(props) {
        super(props)
        console.log("UnableToExamModal=> ", props)
        this.state = {
            appointment: props.appt? props.appt: "",
            patientId: props.appt && props.appt.patient ? props.appt.patient.id : "",
            selectedDbqs: [],
            reason: "",
            text1: "",
            showTextOther: false,
            showSpinner: false
        }
    }
    componentDidMount() {
        // let { appointment } = this.state
        // let newDisab = []
        // if (appointment.disabilities && appointment.disabilities.records && appointment.disabilities.records.length>0) {
        //     for (let disab of appointment.disabilities.records) {
        //         if (!disab.isSigned) {
        //             newDisab.push(disab)
        //         }
        //     }
        //     appointment.disabilities["records"] = []
        //     appointment.disabilities["records"] = newDisab
        //     this.setState({appointment})
        // }
    }

    ifChecked = (disabId) => {
        if (disabId === "all") {
            return this.state.selectedDbqs.length < this.state.appointment.disabilities.records.length ? false: true
        } else {
            return this.state.selectedDbqs.includes(disabId)
        }
    }

    handleOnClick = (disabId) => {
        let { selectedDbqs } = this.state
        if (disabId === "all") {
            if (selectedDbqs && selectedDbqs.length === 0) {
                let disabilities = this.state.appointment.disabilities.records;
                selectedDbqs = []
                for (let disab of disabilities) {
                    selectedDbqs.push(disab.id)
                }
            } else {
                selectedDbqs = []
            }
        } else {            
            if (selectedDbqs.includes(disabId)) {
                const index = selectedDbqs.indexOf(disabId);
                if (index > -1) {
                    selectedDbqs.splice(index, 1); // 2nd parameter means remove one item only
                  }
            } else {
                selectedDbqs.push(disabId)
            }
        }
        
        this.setState({selectedDbqs})
    }

    handleOnchange = (e) => {
        if(e.src === "select") {
            if(e.value === "Other") {
                this.setState({showTextOther: true, reason: e.value})
            } else {
                this.setState({showTextOther: false, reason: e.value})
            }
        } else {
            this.setState({text1: e.value})
        }
        
    }
    handleSubmit = () => {
         let {appointment, selectedDbqs, reason, text1, patientId } = this.state
         let dbqNames = ""
         for (let dbq of selectedDbqs) {
             for (let appt of appointment.disabilities.records) {
                 if (dbq === appt.id) {
                    dbqNames += appt.name+", "
                 }
             }
         }
         dbqNames = dbqNames.substring(0, dbqNames.length-1)
         reason = reason !== "Other" ? reason : text1

         if (selectedDbqs && selectedDbqs.length>0 && reason) {
            let conform = window.confirm("Are you sure you cannot examine " + dbqNames)
            if (conform) {
                this.setState({showSpinner: true})
                let token = localStorage.getItem('login_token');
                let headers = {'Content-Type': 'application/json'};
                headers["Authorization"] = `Bearer ${token}`
                let url = process.env.API_URL+"/patients/unable/exam"
                let body = {
                    dbqIds: selectedDbqs,
                    dbqNames: dbqNames,
                    reason: reason,
                    patientId: patientId
                }
                fetch(url, {method: "PUT", body: JSON.stringify(body), headers})
                .then(response => response.json())
                .then(data => {
                    this.setState({showSpinner: false})
                    if (data.success) {
                        this.props.onClose()
                        window.location.reload()
                    }
                })
                .catch(err => {
                    this.setState({showSpinner: false})
                    console.error(err)
                });
            }
         }
         
    }

    render() {
        const {
            onClose
          } = this.props
          const { appointment } = this.state;
          let disabilities = appointment.disabilities.records;

        return (
            <div className="overlay-msg" style={{color: '#333'}}>
                {this.state.showSpinner && <LoadingContainer/>}
                <div className="overlay-box">
                    <h1><b>Unable to Examine</b></h1>
                    <h5>Please indicate which exam you are unable to complete</h5>
                    <Row className="">
                    <Row style={{marginBottom: 15}}>
                            <Col sm={2}></Col>
                            <Col sm={2} style={{marginRight: 'inherit'}}>
                                <span>
                                    <FormControl 
                                    type="checkbox"
                                    key={"all"}
                                    name="radioFieldTiles" 
                                    checked={this.ifChecked("all")}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => { this.handleOnClick("all")}}
                                    /> 
                                </span>
                                
                            </Col>
                            <Col sm={8} style={{textAlign: 'left', fontSize: 18}}>All</Col>
                            </Row>
                            {disabilities.map((disability, i) => {
                            return <Row sm={12} style={{marginBottom: 15}}>
                            <Col sm={2}></Col>
                            <Col sm={2} style={{marginRight: 'inherit'}}>
                                <span>
                                    <FormControl 
                                    type="checkbox"
                                    key={i}
                                    name="radioFieldTiles" 
                                    checked={this.ifChecked(disability.id)}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => { this.handleOnClick(disability.id)}}
                                    /> 
                                </span>
                                
                            </Col>
                            <Col sm={8} style={{textAlign: 'left', fontSize: 18}}>{disability.name}</Col>
                            </Row>
                        })}
                    </Row>
                    <Row sm={12} style={{marginBottom: 15}}>
                            
                            <Col sm={12}>
                                <span>
                                    <FormControl 
                                    type="select"
                                    componentClass="select"
                                    key={"select"}
                                    name="radioFieldTiles" 
                                    value = {this.state.reason}
                                    style={{cursor: 'pointer', border: '1px solid #555', fontSize: 16, height: 45, borderRadius: "10px !important", width: '65%', margin: '0 auto'}}
                                    onChange={e => this.handleOnchange({value: e.target.value, src: "select"})}
                                    >
                                        <option className="" key={"selectOption_0"} value={""} label="Select Reason" />
                                        <option className="" key={"selectOption_1"} value={"Wrong Exam Listed"} label="Wrong Exam Listed" />
                                        <option className="" key={"selectOption_2"} value={"Patient does not want to be examined"} label="Patient does not want to be examined" />
                                        <option className="" key={"selectOption_3"} value={"Other"} label="Other" />
                                        
                                    </FormControl>
                                </span>
                                
                            </Col>
                        </Row>
                        {this.state.showTextOther && <Row sm={12} style={{marginBottom: 15, minHeight: 50}}>
                            
                            <Col sm={12} style={{paddingRight: '7%', paddingLeft: '7%'}}>
                                <span>
                                    <FormControl autoFocus
                                    type="text"
                                    key={"input"}
                                    name="text1" 
                                    value={this.state.text1}
                                    placeholder= "Please enter the reason"
                                    style={{border: '1px solid #555', fontSize: 16, height: 45, width: '70%', margin: '0 auto'}}
                                    onChange={e => this.handleOnchange({value: e.target.value, src: "text"})}
                                    />
                                </span>
                                
                            </Col>
                        </Row>}
                        {!this.state.showTextOther && <div style={{height: 65}}>

                        </div>
                        }
                    <Row className="backnext-btn-div">
                        <Col xs={6}  className='text-center'>
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="back-btn ripple"
                                onClick={e => {onClose()}}
                            >Cancel</Button>
                        </Col>
                        <Col xs={6} 
                            className='text-center'>                        
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="next-btn ripple"
                                onClick={e => {this.handleSubmit()}}
                            >Confirm</Button>
                                                
                            
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default UnableToExamModal